<script>
    import {
        DxDataGrid,
        DxFilterPanel,
        DxHeaderFilter,
        DxSearchPanel,
        DxFilterRow,
        DxPager,
        DxPaging,
        DxExport,
        DxToolbar,
        DxItem,
        DxColumn,
        DxStateStoring,
        DxColumnFixing,
        DxSelection
    } from 'devextreme-vue/data-grid';
    import { DxLoadPanel } from 'devextreme-vue/load-panel';

    export default {
        inheritAttrs: false,
        props: {
            storageKey: {
                type: String,
                required: false
            },
            showActions: {
                type: Boolean,
                default: true
            },
            showFilters: {
                type: Boolean,
                default: true
            },
            showToolbar: {
                type: Boolean,
                default: true
            },
            showExport: {
                type: Boolean,
                default: true
            },
            showSelection: {
                type: Boolean,
                default: false
            },
            enableStoring: {
                type: Boolean,
                default: false
            },
            fixColumns: {
                type: Boolean,
                default: false
            },
            dataSource: {
                type: [Array, Object],
                default: null
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        components: {
            DxDataGrid,
            DxFilterPanel,
            DxHeaderFilter,
            DxSearchPanel,
            DxFilterRow,
            DxPager,
            DxPaging,
            DxExport,
            DxToolbar,
            DxItem,
            DxColumn,
            DxStateStoring,
            DxColumnFixing,
            DxSelection,
            DxLoadPanel
        },
        methods: {
            refresh() {
                return this.$refs['adminGrid'].instance.refresh();
            },
            getSelectedRowKeys() {
                return this.$refs['adminGrid'].instance.getSelectedRowKeys();
            }
        }
    };
</script>

<template>
    <div id="admin-grid-container" style="position: relative">
        <DxLoadPanel
            :visible="isLoading"
            :show-indicator="true"
            :show-pane="true"
            container="#admin-grid-container"
            :position="{ of: '#admin-grid-container' }"
        />
        <DxDataGrid
            ref="adminGrid"
            class="admin-grid"
            :data-source="dataSource"
            :remote-operations="true"
            :rowAlternationEnabled="true"
            :column-auto-width="true"
            :allow-column-reordering="true"
            v-bind="$attrs"
        >
            <!-- Toolbar -->
            <DxToolbar :visible="showToolbar">
                <slot name="toolbar" />
                <DxItem name="exportButton" />
                <DxItem name="searchPanel" />
            </DxToolbar>

            <DxColumn alignment="right" cell-template="actionsCellTemplate" :visible="showActions" :fixed="fixColumns" />
            <!-- columns slot -->
            <slot />

            <template #actionsCellTemplate="{ data }">
                <slot name="actions" :item="data" />
            </template>
            <template #active-header="{ data }">
                <i title="Actives" class="bi bi-check-circle me-2" style="color: green"></i>
                {{ data.column.caption }}
            </template>
            <template #inactive-header="{ data }">
                <i title="Inactives" class="bi bi-dash-circle me-2" style="color: red"></i>
                {{ data.column.caption }}
            </template>
            <!-- Grid Tools -->
            <DxExport :enabled="showExport" />
            <DxFilterRow :visible="showFilters" />
            <DxHeaderFilter :visible="showFilters" />
            <DxFilterPanel :visible="showFilters" />
            <DxSearchPanel :visible="showFilters" :width="300" placeholder="Search..." />
            <DxPaging :page-size="20" />
            <DxPager :allowed-page-sizes="[20, 50, 100, 250]" :show-page-size-selector="true" />
            <DxStateStoring :enabled="enableStoring" type="localStorage" :storage-key="`grid-${storageKey || ''}`" />
            <DxColumnFixing :enabled="fixColumns" />
            <DxSelection
                :visible="showSelection"
                select-all-mode="allPages"
                :show-check-boxes-mode="showSelection ? 'always' : 'none'"
                mode="multiple"
                :allow-select-all="showSelection"
            />
        </DxDataGrid>
    </div>
</template>
